export const reducer = (state, action) => {
  switch (action.type) {
    case 'set_name':
      return {
        ...state,
        firstName: action.payload
      };
    case 'set_last_name':
      return {
        ...state,
        lastName: action.payload
      };
    case 'set_email':
      return {
        ...state,
        email: action.payload
      };
    case 'set_checkbox':
      return {
        ...state,
        privacyChecked: action.payload
      };
    case 'set_vehicle_delivery':
      return {
        ...state,
        vehicleDelivery: action.payload
      };
    case 'set_company_name':
      return {
        ...state,
        companyName: action.payload
      };
    case 'set_building':
      return {
        ...state,
        building: action.payload
      };
    case 'set_phone_number_prefix':
      return {
        ...state,
        prefix: action.payload
      };
    case 'set_phone_number_prefix2':
      return {
        ...state,
        prefix2: action.payload
      };
    case 'set_phone_number_part':
      return {
        ...state,
        phoneNumber: action.payload
      };
    case 'set_product_interest':
        return {
          ...state,
          productInterest: action.payload
        };
    case 'set_phone_number_part_2':
      return {
        ...state,
        phoneNumber2: action.payload
      };
    case 'set_vat_number':
      return {
        ...state,
        vatNumber: action.payload
      };
    case 'set_street':
      return {
        ...state,
        street: action.payload
      };
    case 'set_zip':
      return {
        ...state,
        zip: action.payload
      };
    case 'set_lead_type':
      return {
        ...state,
        leadType: action.payload
      };
    case 'set_notes':
      return {
        ...state,
        notes: action.payload
      };
    default:
      return state;
  }
};

export const initialState = {
  companyName: '',
  firstName: '',
  lastName: '',
  email: '',
  building: '',
  privacyChecked: false,
  vehicleDelivery: '',
  leadType: '',
  notes: ''
};
